__webpack_require__.p = "https://certificate.quantstamp.com/full/exactly-web-authn-owner-plugin/195741fd-c62b-4a88-87b8-020dd454bd59/";